import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface PremiumPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * PremiumPopup - Now redirects to full Pricing page with Stripe integration
 *
 * The popup behavior is kept for backwards compatibility,
 * but it now navigates to /pricing instead of showing a modal.
 */
const PremiumPopup: React.FC<PremiumPopupProps> = ({ isOpen, onClose }) => {
  console.log('🟡 [PremiumPopup.tsx] isOpen:', isOpen);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      console.log('🟡 [PremiumPopup.tsx] Redirecting to /pricing');
      // Close the popup trigger and navigate to pricing page
      onClose();
      navigate("/pricing");
    }
  }, [isOpen, onClose, navigate]);

  // This component no longer renders anything
  // It just handles the redirect when triggered
  return null;
};

export default PremiumPopup;
